/** Server error codes (MESSAGE of RAISE in SQL) → text for people. */
const MESSAGES: Record<string, string> = {
  network: 'Нет связи с сервером. Проверьте интернет и попробуйте ещё раз.',
  studio_not_found: 'Студия не найдена или ещё не опубликована.',
  service_not_found: 'Эта услуга сейчас недоступна.',
  slot_taken: 'Это время только что заняли. Выберите другое — список обновлён.',
  slot_not_offered: 'На это время записаться нельзя. Выберите время из списка.',
  invalid_name: 'Укажите имя.',
  invalid_phone: 'Проверьте номер телефона.',
  invalid_car: 'Укажите автомобиль.',
  invalid_token: 'Ссылка на запись повреждена.',
  idempotency_conflict: 'Запрос уже отправлялся с другого устройства. Обновите страницу.',
  booking_not_found: 'Запись не найдена. Возможно, ссылка устарела.',
  cancel_window_passed: 'Отменить запись онлайн уже нельзя — позвоните в студию.',
  not_cancellable: 'Эту запись уже нельзя отменить.',
  not_subscribable: 'Напоминание можно включить только для активной записи.',
  rate_limited: 'Слишком много запросов. Подождите минуту и попробуйте снова.',
  retry: 'Не получилось с первого раза. Нажмите ещё раз — запись не задвоится.',
  forbidden: 'Нет доступа к этой студии.',
  not_authenticated: 'Войдите в кабинет.',
  version_conflict: 'Запись только что изменили. Обновите карточку и повторите.',
  not_reschedulable: 'Перенести можно только подтверждённую запись.',
  resource_not_eligible: 'Этот пост не подходит для услуги.',
  outside_working_hours: 'Время вне графика. Отметьте «вне графика», если это осознанно.',
  invalid_transition: 'Такой смены статуса нет.',
  refund_exceeds_paid: 'Возврат больше полученной суммы.',
  invalid_amount: 'Сумма должна быть больше нуля.',
  conflicts_with_occupancy: 'На это время пост уже занят записью или блокировкой.',
  invalid_period: 'Проверьте период.',
  block_not_found: 'Блокировка не найдена.',
  invalid_value: 'Проверьте введённые значения.',
  unknown_field: 'Неизвестное поле настроек.',
  service_needs_resource: 'Выберите хотя бы один пост для услуги.',
  hours_overlap: 'Интервалы графика пересекаются.',
  invalid_media_path: 'Файл загружен не туда. Повторите загрузку.',
  gallery_item_not_found: 'Фото уже удалено.',
  assistant_unavailable: 'Помощник сейчас недоступен. Записаться можно как обычно.',
};

export class AppError extends Error {
  constructor(
    readonly code: string,
    readonly detail?: string,
  ) {
    super(code);
  }
}

export function errorText(err: unknown): string {
  if (err instanceof AppError) return MESSAGES[err.code] ?? 'Что-то пошло не так. Попробуйте ещё раз.';
  return MESSAGES.network!;
}

export function errorCode(err: unknown): string {
  return err instanceof AppError ? err.code : 'network';
}
